import React, {Component} from 'react';
import gif404 from './404.gif';
import {Breadcrumb, BreadcrumbItem} from "reactstrap";
import {Link} from "react-router-dom";

export default class NotFound extends Component {
    render() {
        return (
            <div>
                <div className="jumbotron text-center">

                    <div className="container d-flex justify-content-start align-self-stretch  mt-5">
                        <div className="p-2">
                            <h2 className="pag-title">Page not found !</h2>
                        </div>
                        <div className="ml-auto p-2">
                            <Breadcrumb className="">
                                <BreadcrumbItem><Link to="/">home</Link></BreadcrumbItem>
                                {/*<BreadcrumbItem><a href="#">محصولات</a></BreadcrumbItem>*/}
                                <BreadcrumbItem active>404 !</BreadcrumbItem>
                            </Breadcrumb>

                        </div>
                    </div>
                </div>

                <div className="container text-center">
                    <h1 className="deep-purple-text">404!</h1>
                    <p className="deep-orange-text">Page not found !</p>
                    <img src={gif404} alt='404 gif'/>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/misc/NotFound.js